import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";
import { initPostHog } from "@/lib/analytics/posthog";
import "@/index.css";

// Avant le premier rendu : la vue d'arrivée fait partie de ce qu'on mesure.
// Sans clé configurée, l'appel ne fait rien.
initPostHog();

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
